export default __webpack_public_path__ + "static/media/le_neubourg6.e594946e.jpg";